export default {
  title: 'Nowa kategoria',
  form: {
    menus: {
      label: 'Menu',
    },
    printer: {
      label: 'Drukarka',
    },
    type: {
      label: 'Typ',
    },
    name: {
      label: 'Nazwa',
      placeholder: 'Wprowadź nazwę kategorii',
    },
    description: {
      label: 'Opis',
      placeholder: 'Wprowadź opis',
    },
    has_combo_tax: {
      label: 'Podatek combo',
    },
    modifier_groups: {
      label: 'Grupy modyfikatorów',
    },
    image: {
      label: 'Zdjęcie',
    },
    identifiers: {
      label: 'Identyfikatory',
    },
    has_separate_schedule: {
      label: 'Różni się od harmonogramu menu',
    },
  },
  buttons: {
    save: 'Zapisz',
    close: 'Zamknij',
  },
  feedback: {
    missing_info: 'Brakujące informacje',
  },
  toasts: {
    category_got_created: 'Kategoria została utworzona',
    category_got_updated: 'Kategoria została zaktualizowana',
  },
};
